import actions from './actions';

const initState = {
	dataAnswerShortQuestion: [],
	answerShortQuestionDetail: null,
	totalItems: 0,
	loading: false,
};

export default function readAloudReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_ANSWER_SHORT_QUESTION:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_ANSWER_SHORT_QUESTION_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataAnswerShortQuestion: res, totalItems, loading: false };

		case actions.GET_ANSWER_SHORT_QUESTION_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_ANSWER_SHORT_QUESTION_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, answerShortQuestionDetail: res, loading: false };
		}

		case actions.SPEAKING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
